module.exports = __webpack_public_path__ + "img/bilan_ranking.065c1431.png";